import R from 'ramda';
import { handleActions } from 'redux-actions';

import { Actions, MaxMapZoomLevel } from '../constants';

const initialState = {
  location: null,
  uniID: null,

  cityLocalized: '',
  countryLocalized: '',

  latitude: null,
  longitude: null,
  zoomLevel: null,
  minZoomLevel: null,

  initialLatitude: null,
  initialLongitude: null,
  initialZoomLevel: null,

  bounds: {
    leftLng: null,
    rightLng: null,
    topLat: null,
    bottomLat: null,
  },

  infoWindowFor: null,
  highlightedUniverId: null, // FIXME
  highlightedRoomId: null, // FIXME

  scrollwheel: true,

  // isOutdated makes no sense when isAutoSearchEnabled is true.
  isAutoSearchEnabled: true,
  isMobileMapOpen: false,
};

export default handleActions(
  {
    [Actions.LOAD_DONE]: (state, { payload }) => ({
      ...state,
      ...R.pick(['minZoomLevel', 'cityLocalized', 'countryLocalized'], payload),
      latitude: state.latitude ? state.latitude : payload.latitude,
      longitude: state.longitude ? state.longitude : payload.longitude,
      zoomLevel: state.zoomLevel ? state.zoomLevel : payload.zoomLevel,
      initialLatitude: state.initialLatitude
        ? state.initialLatitude
        : payload.latitude,
      initialLongitude: state.initialLongitude
        ? state.initialLongitude
        : payload.longitude,
      initialZoomLevel: state.initialZoomLevel
        ? state.initialZoomLevel
        : payload.zoomLevel,
      // If auto-search is disabled results are now up to date.
      ...(state.isAutoSearchEnabled ? {} : { isOutdated: false }),
    }),

    [Actions.UPDATE_SEARCH_PARAMS]: (
      state,
      { payload: { location, uniID, lat, lng, zoom } },
    ) => {
      const latitude = parseFloat(lat);
      const longitude = parseFloat(lng);
      const zoomLevel = parseInt(zoom, 10);

      return {
        ...state,
        location,
        uniID,
        ...(!Number.isNaN(latitude) && {
          latitude,
        }),
        ...(!Number.isNaN(longitude) && {
          longitude,
        }),
        ...(!Number.isNaN(zoomLevel) && {
          zoomLevel,
        }),
      };
    },

    [Actions.HIGHLIGHT_ROOM]: (state, { payload }) =>
      R.assoc('highlightedRoomId', payload, state),
    [Actions.UNHIGHLIGHT_ROOM]: state =>
      R.assoc('highlightedRoomId', null, state),

    [Actions.HIGHLIGHT_INFO_WINDOW]: state => ({
      ...state,
      scrollwheel: false,
    }),
    [Actions.UNHIGHLIGHT_INFO_WINDOW]: state => ({
      ...state,
      scrollwheel: true,
    }),
    [Actions.UPDATE_BOUNDS]: (state, { payload }) => ({
      ...state,
      bounds: payload,
    }),
    [Actions.UPDATE_MAP_CENTER]: (state, { payload }) => {
      const [longitude, latitude] = payload;

      return {
        ...state,
        longitude,
        latitude,
      };
    },
    [Actions.INCREMENT_MAP_ZOOM_LEVEL]: state => {
      return {
        ...state,
        zoomLevel: Math.min(state.zoomLevel + 1, MaxMapZoomLevel),
      };
    },
    [Actions.UPDATE_MAP]: (
      state,
      { payload: { center, zoom, marginBounds } },
    ) => ({
      ...state,
      latitude: center.lat,
      longitude: center.lng,
      zoomLevel: zoom,
      bounds: {
        leftLng: marginBounds.nw.lng,
        rightLng: marginBounds.se.lng,
        topLat: marginBounds.nw.lat,
        bottomLat: marginBounds.se.lat,
      },
      // If auto-search is disabled results are now outdated.
      ...(state.isAutoSearchEnabled ? {} : { isOutdated: true }),
    }),

    [Actions.DISABLE_MAP]: state => ({
      ...state,
      latitude: initialState.latitude,
      longitude: initialState.longitude,
      zoomLevel: initialState.zoomLevel,
      bounds: initialState.bounds,
    }),

    [Actions.TOGGLE_MAP_AUTO_SEARCH]: (state, { payload: value }) => ({
      ...state,
      isAutoSearchEnabled: value,
      ...(value ? {} : { isOutdated: false }),
    }),

    [Actions.TOGGLE_MOBILE_MAP]: state => ({
      ...state,
      isMobileMapOpen: !state.isMobileMapOpen,
    }),

    [Actions.RESET_MAP]: state => ({
      ...state,
      latitude: state.initialLatitude || initialState.latitude,
      longitude: state.initialLongitude || initialState.longitude,
      zoomLevel: state.initialZoomLevel || initialState.zoomLevel,
      bounds: initialState.bounds,
    }),
  },
  initialState,
);
